<template>
  <div class="box-content">
    <siteSelect :showArea="showSite" :all="true" @change="siteChange"></siteSelect>
    <div class="right-box">
      <a-tabs :activeKey="paneChange" @change="handleTabChange">
        <a-tab-pane tab="巡检单" key="1">
          <div>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检类型">
                      <j-dict-select-tag
                        placeholder="请选择巡检类型"
                        dictCode="inspection_type"
                        v-model="queryParam.category"
                      ></j-dict-select-tag>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检人">
                      <a-tree-select
                        style="width: 100%"
                        :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                        :treeData="userTree"
                        v-model="queryParam.userId"
                        placeholder="请选择巡检人"
                        dropdownClassName="selects"
                        show-search
                        treeNodeFilterProp="title"
                      >
                        <template slot="title" slot-scope="{ title }">
                          {{ title }}
                        </template>
                      </a-tree-select>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      :disabled="disableSubmit"
                      label="巡检模板"
                    >
                      <a-select
                        showSearch
                        :allowClear="true"
                        placeholder="请选择巡检模板"
                        optionFilterProp="children"
                        :disabled="disableSubmit"
                        v-model="queryParam.templateId"
                      >
                        <a-select-option v-for="(item, key) in templateOptions" :key="key" :value="item.id">
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="巡检结果">
                      <j-dict-select-tag
                        placeholder="请选择巡检结果"
                        dictCode="normal_status"
                        v-model="queryParam.status"
                      ></j-dict-select-tag>
                    </a-form-item>
                  </a-col>

                  <template v-if="toggleSearchStatus">
                    <!--            <a-col :md="6" :sm="8">
                                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="天气情况">
                                    <j-dict-select-tag
                                      placeholder="请选择天气情况"
                                      dictCode="weather_status"
                                      v-model="queryParam.weather"
                                    ></j-dict-select-tag>
                                  </a-form-item>
                                </a-col>

                                <a-col :md="6" :sm="8">
                                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="湿度">
                                    <j-dict-select-tag
                                      placeholder="请选择湿度"
                                      dictCode="humidity_status"
                                      v-model="queryParam.humidity"
                                    ></j-dict-select-tag>
                                  </a-form-item>
                                </a-col>-->

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="天气情况">
                        <a-input placeholder="请输入天气情况" v-model="queryParam.weather" />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="湿度">
                        <a-input placeholder="请输入湿度" v-model="queryParam.humidity" />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=""> </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=""> </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开始时间">
                        <a-range-picker
                          :show-time="{ format: 'HH:mm:ss' }"
                          format="YYYY-MM-DD HH:mm:ss"
                          v-model="dates.stime"
                          :placeholder="['开始时间', '结束时间']"
                          @change="onDateStime"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item
                        style="margin-left: 50px"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="结束时间"
                      >
                        <a-range-picker
                          :show-time="{ format: 'HH:mm:ss' }"
                          format="YYYY-MM-DD HH:mm:ss"
                          v-model="dates.etime"
                          :placeholder="['开始时间', '结束时间']"
                          @change="onDateEtime"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                </a-row>
              </a-form>
            </div>

            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <a-button @click="searchReset" icon="reload">重置</a-button>
              <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a-button>
              <!--<a-button v-if="this.loginUser == 'admin'" @click="handleAdd"
                                  type="primary" icon="plus">新增(仅管理员)
                        </a-button>-->
              <!--<a-button icon="download" @click="handleExportXls()">导出</a-button>
               <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="handleImportFile" @change="handleImportExcel">
                   <a-button  type="danger" icon="import" ghost>导入</a-button>
               </a-upload>-->
              <a-dropdown v-if="selectedRowKeys.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="batchDel">
                    <a-icon type="delete" />
                    删除
                  </a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px">
                  批量操作
                  <a-icon type="down" />
                </a-button>
              </a-dropdown>
            </div>

            <!-- table区域-begin -->
            <div>
              <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
                <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
                <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
                >项
                <a style="margin-left: 24px" @click="onClearSelected">清空</a>
              </div>

              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                @change="handleTableChange"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="handleDetail(record)">查看</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handleEdit(record)">评级</a>
                </span>
              </a-table>
            </div>
            <!-- table区域-end -->

            <!-- 表单区域 -->
            <operationEvaluationInspection-drawer
              ref="modalForm"
              :pagePath="pagePath"
              @ok="modalFormOk"
            ></operationEvaluationInspection-drawer>
          </div>
        </a-tab-pane>

        <a-tab-pane tab="派工单" key="2">
          <div>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="故障来源">
                      <j-dict-select-tag
                        dictCode="error_origin"
                        v-model="queryParam.originKey"
                        placeholder="请选择故障来源"
                      ></j-dict-select-tag>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务类型">
                      <j-dict-select-tag
                        dictCode="job_category"
                        v-model="queryParam.category"
                        placeholder="请选择任务类型"
                      ></j-dict-select-tag>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="任务级别">
                      <j-dict-select-tag
                        dictCode="job_level"
                        v-model="queryParam.jobLevel"
                        placeholder="请选择任务级别"
                      ></j-dict-select-tag>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="8">
                    <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人员">
                      <a-tree-select
                        style="width: 100%"
                        :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                        :treeData="userTree"
                        v-model="queryParam.userId"
                        placeholder="请选择处理人员"
                        dropdownClassName="selects"
                        show-search
                        treeNodeFilterProp="title"
                      >
                        <template slot="title" slot-scope="{ title }">
                          {{ title }}
                        </template>
                      </a-tree-select>
                    </a-form-item>
                  </a-col>

                  <template v-if="toggleSearchStatus">
                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="标题">
                        <a-input placeholder="请输入标题" v-model="queryParam.title" />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                        <j-dict-select-tag
                          dictCode="job_status"
                          v-model="queryParam.status"
                          placeholder="请选择状态"
                        ></j-dict-select-tag>
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="截止时间">
                        <a-range-picker
                          format="YYYY-MM-DD"
                          v-model="dates.endTime"
                          :placeholder="['开始时间', '结束时间']"
                          @change="onDateEndTime"
                        />
                      </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="8">
                      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="完成时间">
                        <a-range-picker
                          format="YYYY-MM-DD"
                          v-model="dates.completionTime"
                          :placeholder="['开始时间', '结束时间']"
                          @change="onDateCompletionTime"
                        />
                      </a-form-item>
                    </a-col>
                  </template>
                </a-row>
              </a-form>
            </div>

            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
              <a-button @click="searchReset" icon="reload">重置</a-button>
              <a-button type="dashed" @click="handleToggleSearch" style="margin-left: 15px; margin-right: 50px"
                >{{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a-button>
              <!--          <a-button @click="handleAdd2" type="primary" icon="plus" v-if="queryParam.scope == 1">新增</a-button>
                        <a-button icon="download" @click="handleExportXls()">导出</a-button>
                        <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader"
                                  :action="handleImportFile" @change="handleImportExcel">
                          <a-button type="danger" icon="import" ghost>导入</a-button>
                        </a-upload>-->
              <a-dropdown v-if="selectedRowKeys.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="batchDel">
                    <a-icon type="delete" />
                    删除
                  </a-menu-item>
                </a-menu>
                <a-button style="margin-left: 8px">
                  批量操作
                  <a-icon type="down" />
                </a-button>
              </a-dropdown>
            </div>

            <!-- table区域-begin -->
            <div>
              <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
                <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
                <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
                >项
                <a style="margin-left: 24px" @click="onClearSelected">清空</a>
              </div>

              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :expandIcon="expandIcon"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                @change="handleTableChange"
              >
                <span slot="action" slot-scope="text, record">
                  <a @click="handleDetail2(record)">查看</a>
                  <a-divider type="vertical" />
                  <a href="javascript:;" @click="handleEdit2(record)">评级</a>
                  <!--<a-dropdown>
                       <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                       <a-menu slot="overlay">
                         <a-menu-item v-if="record.status == 1">
                           <a @click="handleCheck2(record, 2)">开始处理</a>
                         </a-menu-item>
                          <a-menu-item v-if="record.status == 2">
                           <a @click="handleCheck2(record, 3)">已处理</a>
                         </a-menu-item>
                         <a-menu-item>
                           <a href="javascript:;" @click="handleEdit2(record)">编辑</a>
                         </a-menu-item>
                         <a-menu-item>
                           <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                             <a>删除</a>
                           </a-popconfirm>
                         </a-menu-item>
                       </a-menu>
                     </a-dropdown>-->
                </span>
              </a-table>
            </div>
            <!-- table区域-end -->

            <!-- 表单区域 -->
            <operationEvaluationOrder-drawer
              ref="modalForm2"
              :pagePath="pagePath"
              @ok="modalFormOk2"
            ></operationEvaluationOrder-drawer>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import OperationEvaluationInspectionDrawer from './modules/OperationEvaluationInspectionDrawer'
import OperationEvaluationOrderDrawer from './modules/OperationEvaluationOrderDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import siteSelect from '@/components/page/siteSelect'
import { queryUserTreeList } from '@/api/api'
import { getAction } from '@api/manage'
import moment from 'moment'

export default {
  name: 'OperationEvaluationList',
  mixins: [JeecgListMixin],
  components: {
    OperationEvaluationInspectionDrawer,
    OperationEvaluationOrderDrawer,
    siteSelect,
  },
  data() {
    return {
      showSite: true,
      // 抽屉默认面板
      paneChange: '1',
      /* 巡检相关开始*/
      /* 模板列表*/
      templateOptions: [],
      pagePath: '/om/inspection/record',
      pageTitle: '运维考评',
      userTree: [], //人员信息
      loginUser: '',
      judgmentValue: '1', // 派工单为管网或者站点名称
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: false,
      },
      pipeColumn: {
        dataIndex: 'pipeName',
        colName: '',
        title: '管网',
        align: 'center',
        sorter: true,
      },
      isorter: {
        column: 'create_time',
        order: 'desc',
      },
      columns: [],
      // 表头
      columns1: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '巡检人',
          align: 'center',
        },
        {
          dataIndex: 'category_dictText',
          colName: 'category',
          title: '巡检类型',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'templateName',
          colName: 'template_id',
          title: '巡检模板',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'stime',
          colName: 'stime',
          title: '开始时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'etime',
          colName: 'etime',
          title: '结束时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'weather',
          colName: 'weather',
          title: '天气情况',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'temperature',
          colName: 'temperature',
          title: '温度（°C）',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'humidity',
          colName: 'humidity',
          title: '湿度（%RH）',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '巡检结果',
          align: 'center',
          sorter: false,
        },
        {
          dataIndex: 'starNum',
          colName: 'star_num',
          title: '巡检考评',
          align: 'center',
          sorter: false,
          customRender: function (t, r, index) {
            if (t) {
              return t + '星级'
            } else {
              return '待评价'
            }
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' },
        },
      ],
      /* 巡检相关结束*/

      /* 派工单相关结束*/
      // 表头
      columns2: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'originKey_dictText',
          colName: 'origin_key',
          title: '故障来源',
          align: 'center',
        },
        {
          dataIndex: 'category_dictText',
          colName: 'category',
          title: '任务类型',
          align: 'center',
        },
        {
          dataIndex: 'jobLevel_dictText',
          colName: 'job_level',
          title: '任务级别',
          align: 'center',
        },
        {
          dataIndex: 'title',
          colName: 'title',
          title: '标题',
          align: 'center',
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '处理人员',
          align: 'center',
        },
        {
          dataIndex: 'endTime',
          colName: 'end_time',
          title: '截止时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'completionTime',
          colName: 'completion_time',
          title: '完成时间',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
        },
        {
          dataIndex: 'starNum',
          colName: 'star_num',
          title: '工单考评',
          align: 'center',
          sorter: false,
          customRender: function (t, r, index) {
            if (t) {
              return t + '星级'
            } else {
              return '待评价'
            }
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
      ],
      /* 派工单相关结束*/
    }
  },
  watch: {},
  /*loadData(arg) {
    if (arg == undefined) {
      arg = 1
    }
    this.initTableData(arg)
  },*/
  created() {
    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showSite = false
      }
    }
    //this.pagePath = '/om/inspection/record'
    this.loginUser = JSON.parse(localStorage.getItem('pro__Login_Username')).value
    // 加载巡检模板列表
    this.queryTemplateList()
    // 加载人员信息
    this.loadTreeList()
    this.columns = this.columns1
    this.queryParam.type = 1 //青岛区分部门查询
  },
  computed: {},
  methods: {
    // 1.站点 2.流域 3.管网  由于没有流域所以1.站点2.管网4.区域
    // 站点选择
    siteChange(data) {
      console.log(data)
      // this.queryParam.siteId = data.data.id
      this.queryParam.scope = data.scope
      this.queryParam.scopeId = data.data.id
      this.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.operationType = data.type
      this.siteId = data.data.id
      this.$refs.modalForm.model.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.$refs.modalForm.model.siteId = data.data.id
      this.$refs.modalForm.model.operationType = data.type

      if (this.pagePath.indexOf('inspection/record') >= 0) {
        if (1 == data.type) {
          this.queryParam.operationType = data.type
          this.pagePath = '/om/inspection/record'
        } else if (2 == data.type) {
          this.queryParam.operationType = data.type
          this.pagePath = '/site/pipe/inspection/record'
        }
        this.spliceColumn(this.pagePath == '/om/inspection/record' ? this.pipeColumn : this.siteColumn)
        if (4 == data.type) {
          // 根据区域
          this.spliceColumn(this.pagePath == '/om/inspection/record' ? this.siteColumn : this.pipeColumn, 1)
        }
      } else if (this.pagePath.indexOf('om/job/order') >= 0) {
        this.columns2.forEach((v, i) => {
          if (v.dataIndex.indexOf('siteName') >= 0 || v.dataIndex.indexOf('pipeName') >= 0) {
            this.columns2.splice(i, 1)
          }
        })

        if (1 == data.type) {
          this.queryParam.operationType = data.type
          this.judgmentValue = data.type
        } else if (2 == data.type) {
          this.queryParam.operationType = data.type
          this.judgmentValue = data.type
        }

        if (4 == data.type) {
          // 根据区域
          this.spliceColumn(1 == this.judgmentValue ? this.siteColumn : this.pipeColumn, 1)
        }
      }

      /*if (2 == data.type || 4 == data.type || (data.data.title ? data.data.title : data.data.name).indexOf('管网') >= 0) {*/
      this.loadData()
    },
    onSelectChange() {},
    moment,
    handleTabChange(key) {
      this.itemKey = key
      this.columns = []
      if (key == '1') {
        // this.hiddenButton = true // 展示本页面确定取消
        //this.loadData()
        this.pagePath = '/om/inspection/record'
        this.columns = this.columns1
      } else {
        this.templateOptions = []
        this.pagePath = '/om/job/order'
        this.columns = this.columns2
      }
      this.loadData()
      this.paneChange = key
    },

    /* 巡检单*/
    onDateStime: function (value, dateArray) {
      this.queryParam.stimeStart = dateArray[0]
      this.queryParam.stimeEnd = dateArray[1]
    },
    onDateEtime: function (value, dateArray) {
      this.queryParam.etimeStart = dateArray[0]
      this.queryParam.etimeEnd = dateArray[1]
    },
    /* 巡检单*/

    /* 派工单*/
    modalFormOk2() {
      this.queryParam = { scopeId: this.queryParam.scopeId, scope: this.queryParam.scope }
      this.queryParam.type = 1 //青岛区分部门查询
      this.loadData()
    },
    searchReset() {
      this.queryParam = { scopeId: this.queryParam.scopeId, scope: this.queryParam.scope }
      this.queryParam.type = 1 //青岛区分部门查询
      this.dates = {}
      this.loadData()
    },
    handleCheck2(record, s) {
      this.$refs.modalForm2.disableSubmit = false
      this.$refs.modalForm2.showEdit = true
      this.$refs.modalForm2.showCheck = false
      this.$refs.modalForm2.edit(record)
    },
    handleEdit2: function (record) {
      this.$refs.modalForm2.title = '编辑：' + this.pageTitle
      this.$refs.modalForm2.disableSubmit = false
      this.$refs.modalForm2.showCheck = false
      this.$refs.modalForm2.showEdit = false
      this.$refs.modalForm2.edit(record)
    },
    handleAdd2: function () {
      this.$refs.modalForm2.title = '新增：' + this.pageTitle
      this.$refs.modalForm2.disableSubmit = false
      this.$refs.modalForm2.showCheck = false
      this.$refs.modalForm2.showEdit = false
      this.$refs.modalForm2.add()
    },
    handleDetail2: function (record) {
      this.$refs.modalForm2.title = this.pageTitle + '详情'
      this.$refs.modalForm2.disableSubmit = true
      this.$refs.modalForm2.showCheck = false
      this.$refs.modalForm2.showEdit = false
      this.$refs.modalForm2.edit(record)
    },
    onDateEndTime: function (value, dateArray) {
      this.queryParam.endTimeStart = dateArray[0]
      this.queryParam.endTimeEnd = dateArray[1]
    },
    onDateCompletionTime: function (value, dateArray) {
      this.queryParam.completionTimeStart = dateArray[0]
      this.queryParam.completionTimeEnd = dateArray[1]
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon(props) {
      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return (
              <a
                style="color: 'black',margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon type="caret-down" />
              </a>
            )
          } else {
            return (
              <a
                style="color: 'black' ,margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon style="color:red" type="caret-right" />
              </a>
            )
          }
        } else {
          return <span style="margin-right:0px"></span>
        }
      }
    },
    /* 派工单*/

    /* 加载 模板列表*/
    queryTemplateList() {
      var that = this
      that.templateOptions = []
      let params = { pageNo: 1, pageSize: 10000 }
      getAction('/om/inspection/template', params).then((res) => {
        if (res.success) {
          // 模板类型
          that.templateOptions = res.result.records
          /*this.idItem = res.result
          this.form.setFieldsValue({ code: 'TPL' + moment().format('YYMMDD') + '00' + this.idItem })*/
        } else {
          console.log(res.message)
        }
      })
      this.queryParam.arg = 1
    },

    //加载人员信息
    loadTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
          this.loading = false
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.ant-form-item-label > label {
  color: black;
}

.ant-form-item-label > label {
  color: black;
}

.box-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.right-box {
  width: calc(98% - 300px);
}
</style>